import { render, staticRenderFns } from "./BunkeringLogTable.vue?vue&type=template&id=4e2d65bc&scoped=true"
import script from "./BunkeringLogTable.vue?vue&type=script&lang=js"
export * from "./BunkeringLogTable.vue?vue&type=script&lang=js"
import style0 from "./BunkeringLogTable.vue?vue&type=style&index=0&id=4e2d65bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d65bc",
  null
  
)

export default component.exports